export const getOrgStatus = (orgStatus, orgStatusMap, organizationId, t) => {
    var _a, _b;
    const fullStatus = orgStatus.find((status) => status.startsWith(organizationId + '_'));
    if (fullStatus) {
        const status = fullStatus.split('_')[1];
        return (_b = (_a = orgStatusMap[status]) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : t('panels.organizations.unknownStatus', { item: status });
    }
    return '';
};
